import React from "react";
import classNames from "classnames";

import "./FlowBox.scss";

interface FlowBoxProps extends React.HTMLProps<HTMLDivElement> {
}

/**
 * Simple flex container, nothing special here
 *
 * @status stable
 */
export class FlowBox extends React.Component<FlowBoxProps, {}> {
  public render() {
    const { className, ...htmlProps } = this.props;

    return (
      <div {...htmlProps} className={classNames(className, "flow-box")}>
        {this.props.children}
      </div>
    );
  }
}
